import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const TextStyle = styled.div`
  color: ${props => props.color};
  font-size: ${props => props.size}px;
  background-color: ${props => props.backgroundColor};
  weight: ${props => props.weight};
  letter-spacing: ${props => props.letterSpacing};
  padding: ${props => props.padding};
`;
const H1Style = styled.div`
  color: #1d1d1d;
  font-size: 60px;
  font-weight: 700;
  font-family: AvenirBold;
  letter-spacing: -0.2px;
  transition: 0.2s;
  padding-bottom: 20px;
  line-height: 100%;
  @media (max-width: 992px) {
    font-size: 42px;
    max-width: 320px;
  }
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;
const PStyle = styled.div`
  color: #8d848d;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.12px;
  line-height: 24px;
`;

const Text = props => (
  <div className='animateHeading'>
    {props.type === 'none' && (
      <TextStyle
        color={props.color}
        size={props.size}
        backgroundColor={props.backgroundColor}
        weight={props.weight}
        letterSpacing={props.letterSpacing}
        padding={props.padding}>
        {props.textString ? props.textString : props.children}
      </TextStyle>
    )}
    {props.type === 'h1' && (
      <H1Style>{props.textString ? props.textString : props.children}</H1Style>
    )}
    {props.type === 'p' && (
      <PStyle>{props.textString ? props.textString : props.children}</PStyle>
    )}
  </div>
);

Text.propTypes = {
  size: PropTypes.number,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.number,
  letterSpacing: PropTypes.number,
  textString: PropTypes.string,
  type: PropTypes.string,
  padding: PropTypes.string
};

Text.defaultProps = {
  size: 20,
  backgroundColor: 'none',
  color: 'black',
  weight: 100,
  letterSpacing: 0.15,
  textString: '',
  type: 'none',
  padding: 'inherit'
};

export { Text };
